export const wsConnect = (host, jwt) => ({ type: 'WS_CONNECT', host, jwt });
export const wsConnecting = () => ({ type: 'WS_CONNECTING' });
export const wsConnected = () => ({ type: 'WS_CONNECTED' });
export const wsDisconnect = () => ({ type: 'WS_DISCONNECT' });
export const wsDisconnected = (reAuthorize) => ({ type: 'WS_DISCONNECTED', reAuthorize });

export const wsError = () => ({ type: 'WS_ERROR' });

export const changeNotification = (entityType, crudType,
  entityId, parentType = 0, parentId = 0) => ({
  type: 'CHANGE_NOTIFICATION', entityType, crudType, id: entityId, parentType, parentId,
});

export const CHANGE_NOTIFICATION = 'CHANGE_NOTIFICATION';
